import React, { useState, useEffect } from "react";
import { Row, Col, Breadcrumb, Card, Form, Table } from 'react-bootstrap';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Editor } from 'primereact/editor';
import { InputText } from "primereact/inputtext";
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import axios from 'axios';
import config from '../../config';
import { useAuth } from "../../context/AuthContext";
import { MultiSelect } from 'primereact/multiselect'; // Import MultiSelect component

const View_Policy = () => {
    const { role, accessToken } = useAuth();
    const [policies, setPolicies] = useState([]); // State to store fetched policies
    const [selectedPolicy, setSelectedPolicy] = useState(null); // State to store selected policy for viewing
    const [visible, setVisible] = useState(false);
    const fetchPolicies = async () => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/policyRoutes/alldistpolicies?policy_type=${role}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}` // Add Authorization header
                }
            });
            setPolicies(response.data || []);
        } catch (error) {
            console.error('Failed to fetch policies', error);
        }
    };

    useEffect(() => {
        fetchPolicies();
    }, []);



    return (
        <>
            <Row className='body_content'>
                <Row className='mx-0'>
                    <Col md={6} lg={5} className='mb-4'>
                        <Breadcrumb>
                            <Breadcrumb.Item active>Policy</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Row className="policyTable">
                        <Col md={12} lg={12} className='mb-4 ps-0'>

                            <Card>
                                <Card.Header><b>List of Policies</b></Card.Header>
                                <Card.Body className='pt-0'>
                                    <Table striped hover size="sm">
                                        <thead>
                                            <tr>
                                                <th>Policy Name</th>
                                                <th>Initiated By</th>
                                                <th>Last Updated By</th>
                                                <th>Last Updated On</th>
                                                <th style={{ width: '160px' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {policies.map((policy) => (
                                                <tr key={policy.policy_id}>
                                                    <td>{policy.policy_name}</td>
                                                    <td>{policy.creator.first_name} {policy.creator.last_name}</td>
                                                    <td>{policy.updater ? (
                                                        `${policy.updater.first_name} ${policy.updater.last_name}`
                                                    ) : (
                                                        "No updates"
                                                    )}</td>
                                                    <td> {policy.updatedAt ? new Date(policy.updatedAt).toLocaleDateString('en-GB') : "—"}</td>
                                                    <td>
                                                        <Button
                                                            className="p-button-sm p-0"
                                                            icon="pi pi-eye"
                                                            rounded
                                                            text
                                                            severity="help"
                                                            onClick={() => { setSelectedPolicy(policy); setVisible(true); }}
                                                        />

                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Dialog
                        visible={visible}
                        style={{ width: '40vw' }}
                        className="policy_modal_padding"
                        onHide={() => { if (!visible) return; setVisible(false); }}
                    >
                        {selectedPolicy && (
                            <Table bordered size="sm" className="polisy_table">
                                <thead>
                                    <tr className="border-0">
                                        <td colSpan={5} className="slslip_card border-0">
                                            <span className="d-block">
                                                <img
                                                    src={require("../../assets/images/logo.png")}
                                                    alt=''
                                                />
                                            </span>
                                            <h5>
                                                <small className="mb-4">THE GRAPHE - A DESIGN STUDIO</small>
                                                {selectedPolicy.policy_subject}
                                            </h5>
                                            <span className="mt-4 d-block text-muted">
                                                {/* Display avatar and name */}
                                                {selectedPolicy.creator || selectedPolicy.updater ? (
                                                    <>
                                                        Update by: {selectedPolicy.creator ? `${selectedPolicy.creator.first_name} ${selectedPolicy.creator.last_name}` : `${selectedPolicy.updater.first_name} ${selectedPolicy.updater.last_name}`}
                                                    </>
                                                ) : (
                                                    <span>Update by: Unknown</span>
                                                )}
                                                &nbsp; | &nbsp; Last Updated: {new Date(selectedPolicy.updatedAt).toLocaleString('en-GB')}
                                            </span>

                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-0">
                                        <td colSpan={4} className="text-start border-0">
                                            <div dangerouslySetInnerHTML={{ __html: selectedPolicy.policy_desc }} />
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr className="border-0">
                                        <td colSpan={4} className="signature text-start border-0 d-flex justify-content-start align-items-center">
                                            <div>
                                                <span className="d-block text-start mt-5">
                                                    <img
                                                        src={require("../../assets/images/sign_n.png")}
                                                        alt=''
                                                        style={{ width: '80px', height: 'auto' }}
                                                    />
                                                </span>
                                                <small className="mb-4">Authorized Signatory</small>
                                            </div>
                                            <img
                                                src={require("../../assets/images/stamp.jpg")}
                                                alt=''
                                                style={{ width: '70px', height: 'auto' }}
                                            />

                                        </td>
                                    </tr>
                                    <tr className="border-0"><td colSpan={4} className="border-0"></td></tr>
                                    <tr className="border-bottom-0">
                                        <td colSpan={4} className="text-center border-0">
                                            <small className="d-block">193/1 MAHATAMA GANDI ROAD, KOLKATA - 700007</small>
                                            <small>Email: <a href="mailto:Saurabh@thegraphe.com" className="text-primary">Saurabh@thegraphe.com</a></small>
                                        </td>
                                    </tr>
                                </tfoot>
                            </Table>
                        )}
                    </Dialog>
                </Row>
            </Row>
        </>
    );
};

export default View_Policy
